import { InnerQueryExpression } from "../InnerQueryExpression";

export class MinCallExpression implements InnerQueryExpression {
    public readonly $discriminator = "MinCall";
    public readonly argument?: InnerQueryExpression;

    public constructor(argument?: InnerQueryExpression) {
        this.argument = argument;
    }
}
